import { useEffect } from "react";

function Utils() {}

Utils.getDateTime = (isoTimestamp) => {
    const date = new Date(isoTimestamp);

    // Get today's date and yesterday's date
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    // Helper function to format "dd mmmm yyyy"
    const formatDate = (date) => {
        const options = { day: "2-digit", month: "long", year: "numeric" };
        return date.toLocaleDateString("en-US", options);
    };

    // Compare dates
    let dateLabel;
    if (date.toDateString() === today.toDateString()) {
        dateLabel = "Today";
    } else if (date.toDateString() === yesterday.toDateString()) {
        dateLabel = "Yesterday";
    } else {
        dateLabel = formatDate(date); // Format as "dd mmmm yyyy"
    }

    // Format the time to "hh:mm:ss am/pm"
    const timeOptions = {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
    };
    const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

    // Combine date label and time
    const finalOutput = `${dateLabel}, ${formattedTime}`;
    return finalOutput;
};

Utils.getCurrentDate = () => {
    let date = new Date();
    //date formate dd mmm yyyy hh:mm:ss am/pm
    return date.toLocaleDateString("en-US", { day: "2-digit", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true });
};

Utils.getISODateFromSelected = (date, timeReset = true) => {
    let endDate = date.endDate;
    let startDate = date.startDate;

    // Create copies of the dates before modifying time
    let startDateObj = new Date(startDate);
    let endDateObj = new Date(endDate);

    if (timeReset) {
        startDateObj.setHours(0, 0, 0, 0);
        endDateObj.setHours(23, 59, 59, 999);
    }

    // Calculate the exact number of days in the range
    const diffTime = Math.abs(endDateObj - startDateObj);
    const daysInRange = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    // Calculate past date range (previous period of same length)
    let pastStartDateObj = new Date(startDateObj);
    pastStartDateObj.setDate(pastStartDateObj.getDate() - daysInRange);

    let pastEndDateObj = new Date(startDateObj);
    pastEndDateObj.setDate(pastEndDateObj.getDate() - 1);

    if (timeReset) {
        pastStartDateObj.setHours(0, 0, 0, 0);
        pastEndDateObj.setHours(23, 59, 59, 999);
    }

    function getISODateAtMidnight(date, type = "start") {
        // Extract year, month, and day
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, "0");

        // Construct the ISO string with time set to midnight or end of day
        return type === "start" ? `${year}-${month}-${day}T00:00:00` : `${year}-${month}-${day}T23:59:59`;
    }

    return {
        startDate: startDateObj,
        endDate: endDateObj,
        startDateAtMidnight: getISODateAtMidnight(startDateObj, "start"),
        endDateAtMidnight: getISODateAtMidnight(endDateObj, "end"),
        pastStartDate: pastStartDateObj,
        pastEndDate: pastEndDateObj,
        pastStartDateAtMidnight: getISODateAtMidnight(pastStartDateObj, "start"),
        pastEndDateAtMidnight: getISODateAtMidnight(pastEndDateObj, "end"),
        daysInRange: daysInRange,
    };
};

Utils.getMidnightDateFromISOString = (isoString, type = "start") => {
    // Extract the date part (everything before the T)
    const datePart = isoString.split("T")[0];

    // Set time based on type
    if (type === "start") {
        // Set to start of day (midnight)
        return `${datePart}T00:00:00.000Z`;
    } else if (type === "end") {
        // Set to end of day (23:59:59.999)
        return `${datePart}T23:59:59.999Z`;
    }

    // Default fallback
    return `${datePart}T00:00:00.000Z`;
};

// Unified date range handling function for analytics
// Utils.getDateRangeForAnalytics = (selectedDates, gateway) => {
//     // Create copies of the dates before modifying time
//     let startDateObj = new Date(selectedDates.startDate);
//     let endDateObj = new Date(selectedDates.endDate);

//     // Set time to beginning and end of day
//     startDateObj.setHours(0, 0, 0, 0);
//     endDateObj.setHours(23, 59, 59, 999);

//     // Calculate the exact number of days in the range
//     const diffTime = Math.abs(endDateObj - startDateObj);
//     const daysInRange = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

//     // Calculate past date range (previous period of same length)
//     let pastStartDateObj = new Date(startDateObj);
//     pastStartDateObj.setDate(pastStartDateObj.getDate() - daysInRange);

//     let pastEndDateObj = new Date(startDateObj);
//     pastEndDateObj.setDate(pastEndDateObj.getDate() - 1);

//     // Set time for past dates
//     pastStartDateObj.setHours(0, 0, 0, 0);
//     pastEndDateObj.setHours(23, 59, 59, 999);

//     // Helper function to get ISO date at midnight
//     function getISODateAtMidnight(date, type = "start") {
//         // Gateway-specific handling
//         if (gateway === "stripe") {
//             // For Stripe: Use proper Date object with toISOString()
//             const newDate = new Date(date);

//             if (type === "start") {
//                 newDate.setHours(0, 0, 0, 0);
//             } else {
//                 newDate.setHours(23, 59, 59, 999);
//             }

//             return newDate.toISOString();
//         } else if (gateway === "razorpay") {
//             // For Razorpay: Use IST-based conversion
//             const istDate = new Date(date.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));

//             if (type === "start") {
//                 istDate.setHours(0, 0, 0, 0);
//             } else {
//                 istDate.setHours(23, 59, 59, 999);
//             }

//             return istDate.toISOString();
//         } else {
//             // Default: Your original logic (no gateway specified)
//             const year = date.getFullYear();
//             const month = String(date.getMonth() + 1).padStart(2, "0");
//             const day = String(date.getDate()).padStart(2, "0");

//             return type === "start" ? `${year}-${month}-${day}T00:00:00` : `${year}-${month}-${day}T23:59:59`;
//         }
//     }

//     return {
//         startDate: startDateObj,
//         endDate: endDateObj,
//         startDateAtMidnight: getISODateAtMidnight(startDateObj, "start"),
//         endDateAtMidnight: getISODateAtMidnight(endDateObj, "end"),
//         pastStartDate: pastStartDateObj,
//         pastEndDate: pastEndDateObj,
//         pastStartDateAtMidnight: getISODateAtMidnight(pastStartDateObj, "start"),
//         pastEndDateAtMidnight: getISODateAtMidnight(pastEndDateObj, "end"),
//         daysInRange: daysInRange,
//     };
// };

Utils.getDateRangeForAnalytics = (selectedDates, isIST = false) => {
    // Create copies of the dates before modifying time
    let startDateObj = new Date(selectedDates.startDate);
    let endDateObj = new Date(selectedDates.endDate);

    // Set time to beginning and end of day
    startDateObj.setHours(0, 0, 0, 0);
    endDateObj.setHours(23, 59, 59, 999);

    // Calculate the exact number of days in the range
    const diffTime = Math.abs(endDateObj - startDateObj);
    const daysInRange = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    // Calculate past date range (previous period of same length)
    let pastStartDateObj = new Date(startDateObj);
    pastStartDateObj.setDate(pastStartDateObj.getDate() - daysInRange);

    let pastEndDateObj = new Date(startDateObj);
    pastEndDateObj.setDate(pastEndDateObj.getDate() - 1);

    // Set time for past dates
    pastStartDateObj.setHours(0, 0, 0, 0);
    pastEndDateObj.setHours(23, 59, 59, 999);

    // Helper function to get ISO date at midnight
    function getISODateAtMidnight(date, type = "start") {
        // ALWAYS send ISO strings with IST timezone to ensure consistency
        // This prevents timezone conversion during client-server communication

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = type === "start" ? "00" : "23";
        const minutes = type === "start" ? "00" : "59";
        const seconds = type === "start" ? "00" : "59";

        // Always append IST timezone (+05:30) to prevent server timezone interpretation
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${isIST ? "+05:30" : ""}`;
    }

    return {
        startDate: startDateObj,
        endDate: endDateObj,
        startDateAtMidnight: getISODateAtMidnight(startDateObj, "start"),
        endDateAtMidnight: getISODateAtMidnight(endDateObj, "end"),
        pastStartDate: pastStartDateObj,
        pastEndDate: pastEndDateObj,
        pastStartDateAtMidnight: getISODateAtMidnight(pastStartDateObj, "start"),
        pastEndDateAtMidnight: getISODateAtMidnight(pastEndDateObj, "end"),
        daysInRange: daysInRange,
    };
};

// Keep this for backward compatibility
Utils.getISODateFromCustomRange = (startDate, endDate) => {
    // Create copies of the dates before modifying time
    let startDateObj = new Date(startDate);
    let endDateObj = new Date(endDate);

    // Set time to beginning and end of day
    startDateObj.setHours(0, 0, 0, 0);
    endDateObj.setHours(23, 59, 59, 999);

    // Calculate the exact number of days in the range
    const diffTime = Math.abs(endDateObj - startDateObj);
    const daysInRange = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    // Calculate past date range (previous period of same length)
    let pastStartDateObj = new Date(startDateObj);
    pastStartDateObj.setDate(pastStartDateObj.getDate() - daysInRange);

    let pastEndDateObj = new Date(startDateObj);
    pastEndDateObj.setDate(pastEndDateObj.getDate() - 1);

    // Set time for past dates
    pastStartDateObj.setHours(0, 0, 0, 0);
    pastEndDateObj.setHours(23, 59, 59, 999);

    // Helper function to get ISO date at midnight
    function getISODateAtMidnight(date, type = "start") {
        // Extract year, month, and day
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, "0");

        // Construct the ISO string with time set to midnight or end of day
        return type === "start" ? `${year}-${month}-${day}T00:00:00` : `${year}-${month}-${day}T23:59:59`;
    }

    return {
        startDate: startDateObj,
        endDate: endDateObj,
        startDateAtMidnight: getISODateAtMidnight(startDateObj, "start"),
        endDateAtMidnight: getISODateAtMidnight(endDateObj, "end"),
        pastStartDate: pastStartDateObj,
        pastEndDate: pastEndDateObj,
        pastStartDateAtMidnight: getISODateAtMidnight(pastStartDateObj, "start"),
        pastEndDateAtMidnight: getISODateAtMidnight(pastEndDateObj, "end"),
        daysInRange: daysInRange,
    };
};

export default Utils;

const useOnClickOutside = (ref, handler) => {
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                handler();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, handler]);
};

export { useOnClickOutside };
